// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
import globalApi from '~/apis/global';
// Others
import { GET_LIST_GLOBAL } from '~/utils/constants/actionType';
import { IQueryParamBase } from '~/utils/interface/common';

export const getListGlobal = createAsyncThunk(GET_LIST_GLOBAL, async (params: IQueryParamBase, { rejectWithValue }) => {
  try {
    const resp = await globalApi.getListGlobal(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
